import * as React from "react";
const SvgVectorDark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 168, height: 95, viewBox: "0 0 168 95", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 95H251V0H70.0068L0 95Z", fill: "#222222" }));
export default SvgVectorDark;
